import { useMemo } from 'react'

import { useTemplateContext } from '../../context/templateContext'
import { useLazyLayerMetaModel } from '../../context/useLazyLayerMetaModel'
import type {
  ConfigurationSimpleValueField,
  SimpleValueSetupField,
} from '../../types/templateModel'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { getSimpleFieldTypeInformation } from './expressionType'

export const useFieldLiteralExpressionInformation = (
  field: SimpleValueSetupField | ConfigurationSimpleValueField,
) => {
  const { templateVersion } = useTemplateContext()
  const metaModel = useLazyLayerMetaModel(templateVersion?.layer?.layerId)
  const { applicationEnumDefinitions } = useApplicationViewOperationsContext()

  return useMemo(
    () =>
      getSimpleFieldTypeInformation({
        field,
        configuredEnums: applicationEnumDefinitions,
        metaModel,
      }),
    [applicationEnumDefinitions, field, metaModel],
  )
}
